import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Typography, 
  Button, 
  Container, 
  Box, 
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider
} from '@mui/material';
import { 
  Home as HomeIcon,
  Error as ErrorIcon,
  ArrowBack as ArrowBackIcon,
  School as SchoolIcon,
  Info as InfoIcon,
  ContactSupport as ContactIcon,
  Login as LoginIcon
} from '@mui/icons-material';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Box 
        sx={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center',
          py: 8
        }}
      >
        <Box textAlign="center" mb={4}>
          <ErrorIcon color="warning" sx={{ fontSize: 80 }} />
          <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
            404 - Page Not Found
          </Typography>
          <Typography variant="h6" color="text.secondary" paragraph>
            Sorry, we couldn't find the page you're looking for.
          </Typography>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<ArrowBackIcon />}
            sx={{ mt: 2 }}
          >
            Go back home
          </Button>
        </Box>
        
        <Paper elevation={2} sx={{ borderRadius: 2 }}>
          <Box p={3}>
            <Typography variant="h6" gutterBottom>
              You might be looking for:
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <List>
              <ListItem 
                button 
                component={Link} 
                to="/"
                sx={{ borderRadius: 1 }}
              >
                <ListItemIcon>
                  <HomeIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Home Page" />
              </ListItem>
              
              <ListItem 
                button 
                component={Link} 
                to="/subscriptions"
                sx={{ borderRadius: 1 }}
              >
                <ListItemIcon>
                  <SchoolIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Subscription Plans" />
              </ListItem>
              
              <ListItem 
                button 
                component={Link} 
                to="/about"
                sx={{ borderRadius: 1 }}
              >
                <ListItemIcon>
                  <InfoIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="About Us" />
              </ListItem>
              
              <ListItem 
                button 
                component={Link} 
                to="/contact"
                sx={{ borderRadius: 1 }}
              >
                <ListItemIcon>
                  <ContactIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Contact Us" />
              </ListItem>
              
              <ListItem 
                button 
                component={Link} 
                to="/login"
                sx={{ borderRadius: 1 }}
              >
                <ListItemIcon>
                  <LoginIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Login" />
              </ListItem>
            </List>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound; 